// Consent checkbox validity exposure (owner re-pass 2026-08-06): a required
// unchecked checkbox is natively "invalid" from first paint, and VoiceOver
// announces "invalid data" before the user has done anything. The markup
// ships aria-invalid="false" (explicit ARIA outranks internal validity);
// this flips it to true exactly when it is earned — the browser's `invalid`
// event, which fires only when a submit is blocked — and back on change.
// Delegated + capture (invalid does not bubble); idempotent across multiple
// signups and duplicate script tags.
try {
  if (!window.__signupConsentGuard) {
    window.__signupConsentGuard = true;
    document.addEventListener('invalid', (event) => {
      if (event.target?.matches?.('[data-element="signup-consent"]')) {
        event.target.setAttribute('aria-invalid', 'true');
      }
    }, true);
    document.addEventListener('change', (event) => {
      if (event.target?.matches?.('[data-element="signup-consent"]')) {
        event.target.setAttribute('aria-invalid', 'false');
      }
    });
  }
} catch (error) {
  // Degrades to the native bubble; aria-invalid simply stays "false".
}
